import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'

type HeaderProps = React.HTMLAttributes<HTMLElement> & {
  ref?: React.Ref<HTMLElement>
}

export function DiscoverHeader({ className, children }: HeaderProps) {
  const [offset, setOffset] = useState(0)

  useEffect(() => {
    const onScroll = () => {
      setOffset(document.body.scrollTop || document.documentElement.scrollTop)
    }

    // Add scroll listener to the body
    document.addEventListener('scroll', onScroll, { passive: true })

    // Clean up the event listener on unmount
    return () => document.removeEventListener('scroll', onScroll)
  }, [])
  return (
    <header
      className={cn(
        'discover-header sticky top-0 z-50 w-[inherit] transition-all duration-300',
        offset > 5 ? 'shadow' : 'shadow-none',
        className
      )}
    >
      <div
        className={cn(
          'relative flex h-full w-full items-center px-4 py-2 sm:px-6 sm:py-3',
          // 如果传入了 flex-col，则应用多行布局所需的类
          className?.includes('flex-col') ? 'flex-col items-stretch gap-4' : 'gap-3',
          offset > 5 &&

          'after:bg-background/20 after:absolute after:inset-0 after:-z-10 after:backdrop-blur-lg'
        )}
      >
        {children}
      </div>
    </header>
  )
}
